<template>
  <span style="display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{time}}</span>
</template>

<script>
  export default{
    name: 'CountTime',
    props: {
      endTime: {
        type: String
      },
      type: {
        type: String,
        default:'all'
      }
    },
    data () {
      return {
        time: '',
        flag: false
      }
    },
    mounted () {
      let time = setInterval(() => {
        if (this.flag === true) {
          clearInterval(time)
        }
        this.timeDown()
      }, 500)
    },
    methods: {
      // 倒计时
      timeDown () {
        const endTime = new Date(new Date(Date.parse(this.endTime.replace(/-/g, '/'))))
        const nowTime = new Date()
        if (endTime.getTime() - nowTime.getTime() <= 0) {
          if(this.type == 'ending'){
            this.time = `${0}天${0}时${0}分`
          }else{
            this.time = `${0}天${0}时${0}分${0}秒`
          }
        } else {
          let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
          let d = parseInt(leftTime / (24 * 60 * 60))
          let h = this.formate(parseInt(leftTime / (60 * 60) % 24))
          let m = this.formate(parseInt(leftTime / 60 % 60))
          let s = this.formate(parseInt(leftTime % 60))
          if (leftTime <= 0) {
            this.flag = true
            this.$emit('time-end')
          }
          if(this.type == 'ending'){
            this.time = `${d}天${h}时${m}分`     // 需要修改时间样式的话 ，比如需要什么30分钟倒计时，就只保留分和秒
          }else{
            this.time = `${d}天${h}时${m}分${s}秒`     // 需要修改时间样式的话 ，比如需要什么30分钟倒计时，就只保留分和秒
          }

        }
      },
      formate (time) {
        if (time >= 10) {
          return time
        } else {
          return `0${time}`
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/count-time.vue